export const applySurrealismStyle = async (canvas, ctx, setMessage, language) => {
  // 초현실주의: 꿈같고 환상적인 효과
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 색상 변형과 왜곡
  for (let i = 0; i < data.length; i += 4) {
    data[i] = Math.min(255, data[i] * (1 + Math.sin(i * 0.01) * 0.3));
    data[i + 1] = Math.min(255, data[i + 1] * (1 + Math.cos(i * 0.01) * 0.3));
    data[i + 2] = Math.min(255, data[i + 2] * (1 + Math.sin(i * 0.005) * 0.3));
  }
  
  ctx.putImageData(imageData, 0, 0);
};